"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatStructuredAddressAnswer = exports.formatAddressForDisplay = exports.formatAddress = exports.structuredAddressFromValues = exports.parseStructuredAddress = exports.serializeStructuredAddress = exports.isStructuredAddressComplete = exports.structuredAddressRequiresRegion = void 0;
const country_1 = require("../internationalization/enums/country");
const region_1 = require("../internationalization/region");
const STRUCTURED_ADDRESS_REQUIRED_KEYS = ["address", "city", "postalCode", "country"];
const STRUCTURED_ADDRESS_KEYS = [...STRUCTURED_ADDRESS_REQUIRED_KEYS, "region"];
const structuredAddressRequiresRegion = (country) => country === country_1.CountryCode.CA ||
    country === country_1.CountryCode.US ||
    country === country_1.CountryNames.Canada ||
    country === country_1.CountryNames.UnitedStates;
exports.structuredAddressRequiresRegion = structuredAddressRequiresRegion;
const isStructuredAddressComplete = (address) => {
    const requiresRegion = (0, exports.structuredAddressRequiresRegion)(address.country);
    return (STRUCTURED_ADDRESS_REQUIRED_KEYS.every((key) => address[key].trim().length > 0) &&
        (!requiresRegion || address.region.trim().length > 0));
};
exports.isStructuredAddressComplete = isStructuredAddressComplete;
const serializeStructuredAddress = (address) => (0, exports.isStructuredAddressComplete)(address) ? JSON.stringify(address) : null;
exports.serializeStructuredAddress = serializeStructuredAddress;
const parseStructuredAddress = (value) => {
    if (!value) {
        return null;
    }
    try {
        const parsed = JSON.parse(value);
        if (typeof parsed !== "object" ||
            parsed === null ||
            !STRUCTURED_ADDRESS_KEYS.every((key) => typeof parsed[key] === "string")) {
            return null;
        }
        return parsed;
    }
    catch {
        return null;
    }
};
exports.parseStructuredAddress = parseStructuredAddress;
const structuredAddressFromValues = (values) => ({
    address: typeof values[0] === "string" ? values[0] : "",
    city: typeof values[1] === "string" ? values[1] : "",
    postalCode: typeof values[2] === "string" ? values[2] : "",
    country: typeof values[3] === "string" ? values[3] : "",
    region: typeof values[4] === "string" ? values[4] : "",
});
exports.structuredAddressFromValues = structuredAddressFromValues;
const formatAddress = ({ address, city, region, postalCode, country }) => {
    return [address, city, [region, postalCode].filter((part) => part).join(" "), country]
        .filter((part) => part)
        .join(", ");
};
exports.formatAddress = formatAddress;
// Like formatAddress but renders the region code as its canonical accented name (e.g. "Québec",
// not "QC"). Use for user-facing addresses; formatAddress stays raw for geocoding and indexing.
const formatAddressForDisplay = ({ address, city, region, postalCode, country }) => {
    return (0, exports.formatAddress)({
        address,
        city,
        region: (0, region_1.getRegionDisplayName)(country, region) || region,
        postalCode,
        country,
    });
};
exports.formatAddressForDisplay = formatAddressForDisplay;
const formatStructuredAddressAnswer = (answer) => {
    const structuredAddress = (0, exports.parseStructuredAddress)(answer);
    return structuredAddress ? (0, exports.formatAddressForDisplay)(structuredAddress) : (answer ?? "");
};
exports.formatStructuredAddressAnswer = formatStructuredAddressAnswer;
